// Signers on a transaction. Each additional contact (2nd, 3rd, 4th...) has a "signer" flag.
// Missing flag = signer (older records). signer === false = still on emails/CCs, but left out of
// signer names, merge fields, and title / doc-prep info.
export const isSigner = (c) => Boolean(c) && c.signer !== false;
export const hasName = (c) => Boolean(c && (c.firstName || c.lastName));
export const signerContacts = (tx) => (tx?.additionalContacts || []).filter((c) => hasName(c) && isSigner(c));
export const firstSigner = (tx) => signerContacts(tx)[0] || {};
